var pagerIndex=-1;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);


function activateAnchorMenu(index) {
    $('.frame-type-menu_section a').removeClass('active');
    $('.frame-type-menu_section a').eq(index).addClass('active');

    $('#section-menu-pager li').removeClass('active');
    $('#section-menu-pager li').eq(index).addClass('active');


    pagerIndex=-1;
}


if (isSafari && $('html').hasClass('touchevents')) {
    setTimeout(function () {
        $('.search-item').each(function (i) {
            var h = $(this).height();
            $(this).css('height', h + 'px');

        });
    }, 500);

    $(window).resize(function () {
        waitForFinalEvent(function () {
            $('.equal-item').each(function (i) {
                $(this).attr('style', '');
                var h = $(this).height();
                $(this).css('height', h + 'px');
            });
        }, 500, "some unique string");
    });
}




var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout (timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();




/**
 * Main Script
 */
$(document).ready(function() {


    //cookies
    $('#tx_cookies_accept input').click(
        function() {
            setTimeout(
                function() {
                    location.reload();
                },
                500);
        });



    // Youtube Video bei Click auf Vorschaubild nachladen
    $('.youtube-player-placeholder .image').click(function() {
        var image=$(this);
        var container = image.parent();
        var video = '<iframe class="video" src="https://www.youtube-nocookie.com/embed/' + container.data('youtube-key') + '?hd=1&controls=1&modestbranding=0&rel=0&autoplay=1&showinfo=0" frameborder="0" allowfullscreen></iframe>';
        image.replaceWith(video);
    })


    $('#top .search-button').click(function() {
        $('#meta-navigation nav').toggleClass('gray-out');
        $('#kb-menu-dropdown').toggleClass('gray-out');
        $('#top .search-wrapper').toggleClass('active');
    })



    if ($('main #tx-indexedsearch-searchbox-sword').length) {
        if ($('main #tx-indexedsearch-searchbox-sword').val() != "") {
            document.title = 'Sie haben nach ' + $('main #tx-indexedsearch-searchbox-sword').val() + ' gesucht.';
        }
    }



    // ----------------------------------------------------------------------------------
    // Suche in Downloadliste
    // ----------------------------------------------------------------------------------


    $('#ttcontent-search-keyword').on('keypress',function(e) {
        if(e.which == 13) {
            ttContentSearch();
        }
    });




    $('#ttcontent-search-start').click(function() {
        ttContentSearch();
    })


    function ttContentSearch() {
        $('.frame-type-uploads').each(function(i) {
            results=0;

            $(this).find('.search-item').each(function(i) {
                keyword= $('#ttcontent-search-keyword').val().toLowerCase();

                document.title = 'Du hast nach '+keyword+' gesucht.';


                title=$(this).find('.ce-uploads-fileName').text().toLowerCase();

                result=title.search(keyword);



                if (keyword!="") {
                    if (result > -1) {
                        $(this).fadeIn(300);
                        results++;
                    }
                    else {
                        $(this).fadeOut(300);
                    }
                }
                else
                {
                    $(this).fadeIn(300);
                }


            });

            console.log(results);

            if (results==0) {
                $(this).find('.search-result-info').fadeIn(300);
            }
            else {
                $(this).find('.search-result-info').fadeOut(300);
            }
        });
    }







    // ----------------------------------------------------------------------------------
    // TooltipAnkerpunkte
    // ----------------------------------------------------------------------------------

    var pager='<ul>';
    $('.frame-type-menu_section a').each(function(i) {
        title=$(this).text();

        pager+='<li><span class="tooltipp">'+title+'</span></li>'
    });
    pager+='</ul>'
    $('#section-menu-pager').html(pager);


    // ----------------------------------------------------------------------------------
    // Ankerpunkte
    // ----------------------------------------------------------------------------------
    //$('a[href*="#"]:not([href="#"]):not([data-toggle])').click(function(e) {
    $('.frame-type-menu_section a').click(function(e) {
        index=$('.frame-type-menu_section a').index($(this));
        pagerIndex=index;


        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            scrollToTarget(target);
            e.preventDefault();
        }
    });


    // ----------------------------------------------------------------------------------
    // Ankerpunkte als Pager
    // ----------------------------------------------------------------------------------


    $( "#section-menu-pager" ).on( "click", "li", function() {
        index=$(this).index();
        pagerIndex=index;
        $('.frame-type-menu_section a').eq(index).click();
    });

    // ----------------------------------------------------------------------------------
    // Versucht Ankerpunkte anhand der Scrollposition zu erkennen
    // ----------------------------------------------------------------------------------

    $(window).scroll(function() {
        var scrollDistance = $(window).scrollTop();

        windowheight= $(window).height();
        innerheightLeft= $('#main-column-left .inner').height();
        innerheightRight= $('#main-column-right .inner').height();
        leftcolwidth=$('#main-column-left').width();
        viewport=windowheight-$('#top').height();



        if (innerheightRight<viewport || innerheightLeft>=innerheightRight || (innerheightLeft+100)>=viewport) {
            $('#main-column-left .inner').removeClass('fixed').addClass('scrollable');
            $('#main-column-left .inner').attr('style','');
        }
        else
        {
            $('#main-column-left .inner').removeClass('scrollable').addClass('fixed');


            offset=scrollDistance-($('#main-column-right').height()-viewport);


            if ($('#main-column-left .inner.fixed').css('position')=='fixed') {

                $('#main-column-left .inner').css('width',leftcolwidth+'px');


                if (scrollDistance) {
                    $('#main-column-left .inner.fixed').css('transform', 'translate(0,-' + offset + 'px)');
                }
                else {
                    $('#main-column-left .inner.fixed').css('transform', 'translate(0,' + 0 + 'px)');
                }
            }

            // Assign active class to nav links while scolling
            $('.frame-type-menu_section a').each(function (i) {

                var href = $(this).attr('href');

                var anchor = href.split('#');

                if ($('#' + anchor[1]).position().top <= scrollDistance + 210) {

                    $('.frame-type-menu_section a').removeClass('active');
                    $('.frame-type-menu_section a').eq(i).addClass('active');

                    $('#section-menu-pager li').removeClass('active');
                    $('#section-menu-pager li').eq(i).addClass('active');

                }
            });


            if ((scrollDistance+windowheight)==$(document).height()) {
                e=$('.frame-type-menu_section a').length-1;
                activateAnchorMenu(e);
            }

        }


    }).scroll();





    /* Druckbutton*/

    $('.button-print').click(function() {
        window.print();
    })



    /* Bewerbungsbutton*/

    $('.application').click(function() {
        var value=$(this).data('application');

        // console.log(value);

        $('#powermail_field_jobs').val(value).change();


        scrollToTarget($('.frame-layout-box-gray'));


    })



    // Referenzfinder
    $("#finder-category").change(function() {
       var data= '#'+$("#finder-category").val()+'#';

       var results = 0;


       if ($("#finder-category").val()!="") {
           $('.reference-item').not('[data-categories*="' + data + '"]').fadeOut(500);
           $('.reference-item[data-categories*="' + data + '"]').fadeIn(500);

           if ( $('.reference-item[data-categories*="' + data + '"]').length==0) {
               $('#no-results-references').fadeIn(500);
           }
           else {
               $('#no-results-references').fadeOut(500);
           }



       }
       else {
           $('.reference-item').fadeIn(500);
           $('#no-results-references').fadeOut(500);
       }

    });


    // Newsfinder
    $("#finder-years").change(function() {
        var data= $("#finder-years").val();

        if (data!="") {
            $('.news-list-group').not('[data-year="' + data + '"]').fadeOut(500);
            $('.news-list-group[data-year="' + data + '"]').fadeIn(500);
        }
        else {
            $('.news-list-group').fadeIn(500);
        }

    });


    // Design-Element für Checkboxen
    $("input[type='checkbox'] + label").prepend("<span></span>");


    // Equal-Height / MatchHeight
    var $equalHeight = $(".equal-height");
    if ($equalHeight.length > 0) {
        $equalHeight.matchHeight(); 

        // Tabs in Equal-Height Container
        $equalHeight.find("a[data-toggle='tab']").on("shown.bs.tab", function() {
            $.fn.matchHeight._update(); 
        });
    }


    // ContentImage
    var $contentImage = $(".content-image");
    if ($contentImage.length > 0) {
        $(".zoom-icon-link").click(function(e) {
            e.preventDefault();
            $(this).parents(".image-frame").find(".content-image-link").click();
            return false;
        });
    }




    // Hash schon beim Laden vorhanden?
    var hash = window.location.hash;
    var target = $(hash);
    scrollToTarget(target);


    function scrollToTarget(target) {
        if (target.length) {
            $('html, body').animate({
                scrollTop: (target.offset().top - 80)
            }, 1000,function () {
                if (pagerIndex>=0) {
                    activateAnchorMenu(pagerIndex);
                }
            });
            return false;
        }
    }


    // ----------------------------------------------------------------------------------
    // Fancy Input field preparation
    // ----------------------------------------------------------------------------------
    var $fancyInputFieldWrap = $("form").find(".kb-fancy-inputfield");
    if ($fancyInputFieldWrap.length > 0) {
        $fancyInputFieldWrap.find(".form-control").each(function() {
            if ($(this).val().trim().length > 0) {
                $(this).parents(".kb-fancy-inputfield").addClass("has-focus");
            }
            $(this).on("focus", function() { $(this).parents(".kb-fancy-inputfield").addClass("has-focus"); });
            $(this).on("blur", function() {
                if ($(this).val().trim() === "") {
                    $(this).parents(".kb-fancy-inputfield").removeClass("has-focus");
                }
            })
        });
    }

    // ----------------------------------------------------------------------------------
    // Back-To-Top-Button
    // ----------------------------------------------------------------------------------
    // var $back2TopButton = $('<a href="#top" class="back2top hidden-xs"></a>').appendTo("body");
    // $(window).scroll(function() {
    //     if (!$("body").hasClass("noscroll") && $(this).scrollTop() > 200) { // Wenn 200 Pixel gescrolled wurde
    //         $back2TopButton.fadeIn();
    //     } else {
    //         $back2TopButton.fadeOut();
    //     }
    // });
    // $back2TopButton.hide();
    // $back2TopButton.click(function(e) { // Klick auf den Button
    //     e.preventDefault();
    //     $('body,html').animate({ scrollTop: 0 }, 500);
    //     return false;
    // });

    
    var cookieMessage="Cookies sind für die Bereitstellung unserer Dienste erforderlich. Mit der Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies verwenden. <a href=\"/footer-menu/impressum/\">Impressum</a> | <a href=\"/footer-menu/datenschutzerklaerung/\">Datenschutzerklärung</a>";
    var cookieDismiss="Einverstanden";

    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#0E284C"
            },
            "button": {
                "background": "#97C11F"
            }
        },
        "content": {
            "message": cookieMessage,
            "dismiss": cookieDismiss,
            "link": false,
            "href": false
        }
    });
});
